import React from 'react';
import {
  Radio,
  FormGroup
} from 'react-bootstrap';

class RadioButtonGroup extends React.Component {
  constructor(props) {
    super(props);

    const checked = props.initialChecked
      || (props.options.length > 0 && props.options[0].value);

    this.state = {
      checked
    };
  }

  factoryHandleCheck(checked) {
    return () => {
      this.setState({ checked });
      this.props.onChange && this.props.onChange(checked);
    }
  }

  renderButtons() {
    const { options, name } = this.props,
      checked = this.state.checked;

    return options.map((opt, index) => {
      return (
        <Radio
          name={ name }
          value={ opt.value }
          checked={ checked === opt.value }
          key={ opt.value }
          onChange={ this.factoryHandleCheck(opt.value) }
        >
          { opt.label }
        </Radio>
      );
    });
  }

  render() {
    return (
      <FormGroup className="radio-button">
        { this.renderButtons() }
      </FormGroup>
    )
  }
}

export default RadioButtonGroup;



// WEBPACK FOOTER //
// ./src/components/Selects/RadioButtonGroup.js